import { apiClient } from './client'
import { API_ENDPOINTS } from '@/utils/constants'
import type { LessonPaymentMethod, LessonPaymentState } from '@/types/billing'

type ApiResponse<T> = { message?: string; data?: T }

function unwrapResource<T>(raw: ApiResponse<T> | T): T {
  if (raw && typeof raw === 'object' && 'data' in raw) {
    return (raw as ApiResponse<T>).data as T
  }
  return raw as T
}

export type FinalizeIndividualPaymentPayload = {
  payment_method?: LessonPaymentMethod
}

export type FinalizeGroupPaymentPayload = {
  entries?: Array<{
    student_id: number
    payment_method: LessonPaymentMethod
  }>
}

export const lessonPaymentsApi = {
  get: async (lessonId: number): Promise<LessonPaymentState> => {
    const response = await apiClient.get<ApiResponse<LessonPaymentState>>(
      API_ENDPOINTS.LESSON_API.PAYMENT(lessonId)
    )
    return unwrapResource(response.data)
  },

  finalize: async (
    lessonId: number,
    payload: FinalizeIndividualPaymentPayload | FinalizeGroupPaymentPayload
  ): Promise<LessonPaymentState> => {
    const response = await apiClient.post<ApiResponse<LessonPaymentState>>(
      API_ENDPOINTS.LESSON_API.PAYMENT(lessonId),
      payload
    )
    return unwrapResource(response.data)
  },

  update: async (
    lessonId: number,
    payload: FinalizeIndividualPaymentPayload | FinalizeGroupPaymentPayload
  ): Promise<LessonPaymentState> => {
    const response = await apiClient.patch<ApiResponse<LessonPaymentState>>(
      API_ENDPOINTS.LESSON_API.PAYMENT(lessonId),
      payload
    )
    return unwrapResource(response.data)
  },
}
